/* ==========================================================================
   Billing Toggle Component
   Task F33: Monthly/Annual pill toggle for pricing section
   ========================================================================== */

interface BillingToggleProps {
  billingCycle: 'monthly' | 'annual'
  onChange: (cycle: 'monthly' | 'annual') => void
}

export function BillingToggle({ billingCycle, onChange }: BillingToggleProps) {
  return (
    <div className="inline-flex items-center rounded-full bg-charcoal/5 p-1">
      <button
        type="button"
        onClick={() => onChange('monthly')}
        className={`
          rounded-full px-5 py-2 text-sm font-semibold transition-all duration-200
          ${billingCycle === 'monthly'
            ? 'bg-deep-purple text-white shadow-sm'
            : 'text-charcoal/70 hover:text-charcoal'}
        `}
      >
        Monthly
      </button>
      <button
        type="button"
        onClick={() => onChange('annual')}
        className={`
          rounded-full px-5 py-2 text-sm font-semibold transition-all duration-200 flex items-center gap-2
          ${billingCycle === 'annual'
            ? 'bg-deep-purple text-white shadow-sm'
            : 'text-charcoal/70 hover:text-charcoal'}
        `}
      >
        Annual
        <span
          className={`
            text-xs font-bold rounded-full px-2 py-0.5
            ${billingCycle === 'annual'
              ? 'bg-white/20 text-white'
              : 'bg-deep-purple/10 text-deep-purple'}
          `}
        >
          Save ~16%
        </span>
      </button>
    </div>
  )
}

export default BillingToggle
